// Where the built playable ads are served from.
//
// They used to live in this repo under public/playable/. Every rebuild added
// ~59 MB to git history permanently: the exported HTML is base64+zlib inside
// <script> tags, so a one-line code change shifts the compressed bytes through
// the whole file and git stores a near-full new blob each time. They are served
// from S3 instead.
//
// Set REACT_APP_PLAYABLE_BASE_URL in Amplify (and .env.local for `npm start`)
// to the bucket/CDN base, with no trailing slash, e.g.
//   https://lsg-playable-builds.s3.us-east-1.amazonaws.com/playable
//
// If it is unset, this falls back to the in-repo copy, so local dev works
// without AWS and unsetting the variable is a one-click rollback in Amplify.
const PLAYABLE_BASE =
  (process.env.REACT_APP_PLAYABLE_BASE_URL || "").replace(/\/+$/, "") ||
  `${process.env.PUBLIC_URL}/playable`;

// The <slug>/<network>/index.html layout is kept exactly as it was. On Amplify
// it was required -- Amplify redirects /foo.html to /foo/ and rewrites unknown
// extensions to the SPA, so an explicit <dir>/index.html was the only shape
// served verbatim. S3 has no such rewriting, but keeping the layout means the
// same files work from either origin and the fallback above stays honest.
export const playableUrl = (...parts) => `${PLAYABLE_BASE}/${parts.join("/")}`;

export default PLAYABLE_BASE;
